import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

/** Same-origin in production (the Worker serves the SPA); overridable for local dev. */
export const API_ORIGIN = ((import.meta.env.VITE_API_ORIGIN as string | undefined) ?? '').replace(
  /\/+$/,
  '',
);

/**
 * Better Auth client (api store mode). Talks to the Worker's /api/auth/* routes; the session
 * lives in an httpOnly cookie, so nothing here ever sees a token.
 */
export const authClient = createAuthClient({
  baseURL: API_ORIGIN || undefined,
  basePath: '/api/auth',
  plugins: [magicLinkClient()],
});
